import { render } from "./opening.vue?vue&type=template&id=498538bf"
import script from "./opening.vue?vue&type=script&lang=js"
export * from "./opening.vue?vue&type=script&lang=js"

import "./opening.vue?vue&type=style&index=0&id=498538bf&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__